import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';
import { infoSectionTitleStyles } from '@/components/Approval/@components/InfoSection/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤 — 초기 레거시 문서는 제목이 label.label 하나뿐 */
export const SerpStoreClosureRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& h2, & label.label': {
    ...infoSectionTitleStyles,
    display: 'block',
    margin: '0 0 8px',
  },
  '& table': {
    ...approvalFormTableStyles(theme),
    minWidth: 480,
  },
  '& table + table': {
    marginTop: 16,
  },
  '& table th, & table td': {
    textAlign: 'center',
  },
  '& th.alert-primary': {
    fontWeight: 600,
  },
}));
